'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Style = require('../core/Style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getColumnSize = function getColumnSize(value, correction) {
  if (typeof value === 'number') {
    return (0, _Style.remCalc)(value);
  }
  // test for percentage
  if (typeof value === 'string' && /%$/.test(value)) {
    return 'calc(' + value + ' - ' + (0, _Style.remCalc)(correction) + ')';
  }
  // test for px units
  if (typeof value === 'string' && /px$/.test(value)) {
    return (0, _Style.remCalc)(value);
  }
  return value;
};

var getTemplateColumns = function getTemplateColumns(_ref) {
  var columns = _ref.columns,
      columnSize = _ref.columnSize,
      gutterSize = _ref.gutterSize;

  if (columns) return 'repeat(' + columns + ', 1fr)';
  var computedColumnSize = getColumnSize(columnSize, gutterSize);
  return 'repeat(auto-fit, minmax(' + computedColumnSize + ', 1fr))';
};

var getFlexChildFallback = function getFlexChildFallback(_ref2) {
  var columns = _ref2.columns,
      columnSize = _ref2.columnSize,
      gutterSize = _ref2.gutterSize;
  return (0, _styledComponents.css)(['flex-grow:', ';flex-shrink:1;flex-basis:', ';margin-bottom:0;margin-left:', ';margin-right:0;margin-top:', ';'], typeof columnSize === 'string' && /%$/.test(columnSize) ? '0' : '1', getColumnSize(columns ? Math.floor(100 / columns) + '%' : columnSize, gutterSize), (0, _Style.remCalc)(gutterSize), (0, _Style.remCalc)(gutterSize));
};

var CardGrid = _styledComponents2.default.div.withConfig({
  displayName: 'UICardGrid__CardGrid'
})(['display:flex;flex-wrap:wrap;margin-bottom:0;margin-left:-', ';margin-right:0;margin-top:-', ';&& > *{', ';}@supports (display:grid){display:flex;display:grid;grid-column-gap:', ';grid-row-gap:', ';grid-template-columns:', ';margin:0;&& > *{margin:0;}}'], function (props) {
  return (0, _Style.remCalc)(props.gutterSize);
}, function (props) {
  return (0, _Style.remCalc)(props.gutterSize);
}, getFlexChildFallback, function (props) {
  return (0, _Style.remCalc)(props.gutterSize);
}, function (props) {
  return (0, _Style.remCalc)(props.gutterSize);
}, getTemplateColumns);

var CardShim = _styledComponents2.default.div.withConfig({
  displayName: 'UICardGrid__CardShim'
})(['', ';&&{margin-top:0;}@supports (display:grid){display:none;}'], getFlexChildFallback);

var UICardGrid = _react2.default.createClass({
  displayName: 'UICardGrid',

  propTypes: {
    children: _react.PropTypes.node,
    columns: _react.PropTypes.number,
    columnSize: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    gutterSize: _react.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      columnSize: 295,
      expandToFill: true,
      gutterSize: 32
    };
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        columnSize = _props.columnSize,
        gutterSize = _props.gutterSize,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'columnSize', 'gutterSize']);

    return _react2.default.createElement(
      CardGrid,
      _extends({}, rest, {
        className: className,
        columnSize: columnSize,
        gutterSize: gutterSize
      }),
      children,
      _react2.default.createElement(CardShim, { columnSize: columnSize, gutterSize: gutterSize }),
      _react2.default.createElement(CardShim, { columnSize: columnSize, gutterSize: gutterSize }),
      _react2.default.createElement(CardShim, { columnSize: columnSize, gutterSize: gutterSize }),
      _react2.default.createElement(CardShim, { columnSize: columnSize, gutterSize: gutterSize }),
      _react2.default.createElement(CardShim, { columnSize: columnSize, gutterSize: gutterSize })
    );
  }
});

exports.default = UICardGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/card/UICardGrid.js
// module id = 371
// module chunks = 3 4